import FormPaymentData from './FormPaymentData'

export default FormPaymentData
